import type { ChipToggleProps } from '@design/objects/chip-toggle/contract'

let instanceId = 0

export default function (element: string | HTMLElement, config?: Pick<ChipToggleProps, 'onChange'>): void {
  let el: HTMLElement | string | null = element

  if (typeof element === 'string') {
    el = document.querySelector<HTMLElement>(element)
  }

  if (!el || typeof el === 'string') {
    return
  }

  if (el.hasAttribute('data-initialized')) {
    return
  }

  el.setAttribute('data-initialized', 'true')
  el.style.setProperty('--chip-pill-name', `chip-pill-${++instanceId}`)

  const chips = Array.from(el.querySelectorAll<HTMLElement>(':scope > .o-chip'))

  const applySelection = (selectedChip: HTMLElement): void => {
    chips.forEach((chip) => {
      const isSelected = chip === selectedChip

      if (isSelected) {
        chip.setAttribute('data-selected', 'true')
      } else {
        chip.removeAttribute('data-selected')
      }

      if (chip.tagName === 'BUTTON') {
        chip.setAttribute('aria-pressed', String(isSelected))
      } else if (isSelected) {
        chip.setAttribute('aria-current', 'true')
      } else {
        chip.removeAttribute('aria-current')
      }
    })
  }

  const select = (selectedChip: HTMLElement): void => {
    const prefersReducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches

    if (document.startViewTransition && !prefersReducedMotion) {
      document.startViewTransition(() => applySelection(selectedChip))
    } else {
      applySelection(selectedChip)
    }

    const value = selectedChip.getAttribute('data-value')

    if (value !== null) {
      config?.onChange?.(value)
    }
  }

  chips.forEach((chip) => {
    chip.addEventListener('click', () => {
      if (chip.hasAttribute('data-selected')) {
        return
      }

      select(chip)
    })
  })
}
